// @file Integration permissions settings store
import { useDashboardSettingsStore } from '@@/pinia/dashboard_settings'
import type { UserOptions } from '@@/types'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useSettingsIntegrationPermissionsStore = defineStore('settingsIntegrationPermissions', () => {
  const dashboardSettingsStore = useDashboardSettingsStore()
  const { updateUserOptions } = dashboardSettingsStore

  const userOptions = computed<UserOptions>(() => dashboardSettingsStore.userOptions)

  // State
  const googleDriveEmail = ref<string | null | undefined>(undefined)

  // Getters

  // Actions
  function initialize(): void {
    googleDriveEmail.value = userOptions.value.linkedGoogleDriveEmail ?? null
  }

  function setGoogleDriveEmail(email: string): void {
    updateUserOptions({ linkedGoogleDriveEmail: email })
    googleDriveEmail.value = email
  }

  function clearGoogleDriveEmail(): void {
    updateUserOptions({ linkedGoogleDriveEmail: undefined })
    googleDriveEmail.value = null
  }

  return {
    // State
    googleDriveEmail,

    // Getters

    // Actions
    initialize,
    setGoogleDriveEmail,
    clearGoogleDriveEmail,
  }
})
